import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "working-hours-setting-form" }
const _hoisted_2 = {
  class: "pt-2 pl-4",
  style: {"font-weight":"bold"}
}

import MaximumWorkingHoursByDaily from '@/components/OperationOfficeForms/MaximumWorkingHoursByDaily.vue';
import MaximumWorkingHoursMonthly from '@/components/OperationOfficeForms/MaximumWorkingHoursMonthly.vue';
import OperationOfficeSettingsMonthlyReport from '@/types/OperationOfficeSettingsMonthlyReport';
import { computed } from 'vue';
import i18n from '@/lang/i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'MaximumWorkingHoursForm',
  props: {
    modelValue: {},
    errors: {},
    windowInnerWidth: {}
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const emit = __emit

const props = __props

const modelValue = computed({
  get() {
    return props.modelValue
  },
  set(value) {
    emit("update:modelValue", value)
  }
})

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_radio = _resolveComponent("v-radio")!
  const _component_v_radio_group = _resolveComponent("v-radio-group")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_row, { class: "radio-form pl-4 pr-3 mb-2" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, {
          cols: props.windowInnerWidth > 800 ? 2 : 3
        }, {
          default: _withCtx(() => [
            _createElementVNode("h6", _hoisted_2, _toDisplayString(_unref(i18n).global.t('pages.operationOffices.form.maximumWorkingHours.title')), 1)
          ]),
          _: 1
        }, 8, ["cols"]),
        _createVNode(_component_v_col, {
          cols: 
          props.windowInnerWidth <= 800 ||
          (props.windowInnerWidth >= 992 && props.windowInnerWidth <= 1197)
            ? 6
            : 3
        
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_radio_group, {
              modelValue: modelValue.value.over_time_thresholds_type,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((modelValue.value.over_time_thresholds_type) = $event)),
              class: "radio-group-row"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_radio, {
                  value: "0",
                  label: _unref(i18n).global.t('pages.operationOffices.form.maximumWorkingHours.daysSetting'),
                  color: "blue"
                }, null, 8, ["label"]),
                _createVNode(_component_v_radio, {
                  value: "1",
                  label: _unref(i18n).global.t('pages.operationOffices.form.maximumWorkingHours.monthSetting'),
                  color: "blue"
                }, null, 8, ["label"])
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["cols"])
      ]),
      _: 1
    }),
    (modelValue.value.over_time_thresholds_type == 0)
      ? (_openBlock(), _createBlock(_component_v_row, {
          key: 0,
          class: "radio-form pl-4 pr-3 mb-2"
        }, {
          default: _withCtx(() => [
            _createVNode(MaximumWorkingHoursByDaily, {
              modelValue: modelValue.value.over_time_thresholds.daily,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((modelValue.value.over_time_thresholds.daily) = $event)),
              errors: __props.errors,
              windowInnerWidth: props.windowInnerWidth
            }, null, 8, ["modelValue", "errors", "windowInnerWidth"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (modelValue.value.over_time_thresholds_type == 1)
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(modelValue.value.over_time_thresholds.monthly, (time, month) => {
          return (_openBlock(), _createBlock(_component_v_row, {
            key: month,
            class: "pl-4 pr-3 mb-2"
          }, {
            default: _withCtx(() => [
              _createVNode(MaximumWorkingHoursMonthly, {
                modelValue: modelValue.value.over_time_thresholds.monthly[month],
                "onUpdate:modelValue": ($event: any) => ((modelValue.value.over_time_thresholds.monthly[month]) = $event),
                month: month,
                errors: __props.errors,
                windowInnerWidth: __props.windowInnerWidth
              }, null, 8, ["modelValue", "onUpdate:modelValue", "month", "errors", "windowInnerWidth"])
            ]),
            _: 2
          }, 1024))
        }), 128))
      : _createCommentVNode("", true)
  ]))
}
}

})